module.exports = __webpack_public_path__ + "static/SaolDisplay-Medium-8f64f45f8cae32cf59461f260d1e49e0.woff2";